// Copyright (c) 2015-present Mattermost, Inc. All Rights Reserved.
// See LICENSE.txt for license information.

import React from 'react';
import {FormattedMessage} from 'react-intl';
import classNames from 'classnames';

import Badge from './badge';

type Props = {
    className?: string;
    show?: boolean;
};

export const OutOfChannelBadge: React.FC<Props> = (props: Props) => (
    <Badge
        className={classNames('OutOfChannelBadge', props.className)}
        show={props.show}
    >
        <FormattedMessage
            id='post_info.out_of_channel'
            defaultMessage='Not in current channel'
        />
    </Badge>
);
